import React, { useEffect } from 'react';
import moment from 'moment';
import { Badge } from 'react-bootstrap';

import useGlobal from '../../../store';
import Table from '../../../facturotopia/table/Table';
import CancelacionStatus from '../enum/CancelacionStatus';

const mapState = (store) => {
  return store.modulo.cancelaciones.tickets;
};

const mapActions = (actions) => {
  return { ...actions.modulo.cancelaciones.tickets };
};

const CancelacionesTicketList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state;

  useEffect(() => {
    if (data.length === 0) {
      const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
      const to = moment().format('YYYY-MM-DD');

      actions.paginate({
        page: 1,
        from,
        to,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (meta) => {
    const { filters } = state;

    actions.paginate({
      ...filters,
      ...meta,
    });
  };

  const handleOnPageChange = (page) => {
    paginate({ page });
  };

  const handleOnPageLimitChange = (limit) => {
    paginate({ limit, page: 1 });
  };

  const getPaginationConfig = () => {
    const { pagination } = state;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  const setSelectedRows = (event) => {
    actions.setSelectedRows(event);

    !!props.onRowSelectionChange && props.onRowSelectionChange(event);
  };

  const getRowSelectionConfig = () => {
    const { selectedRowKeys = [] } = props;

    return {
      type: 'checkbox',
      selectedRowKeys,
      onChange: setSelectedRows,
      getCheckboxProps: (record) => ({
        name: record.name,
      }),
    };
  };

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      selectable={true}
      pagination={getPaginationConfig()}
      onRow={onRowRender}
      rowSelection={getRowSelectionConfig()}
    ></Table>
  );
};

const renderStatus = (item) => {
  let variant = 'light';

  const status = CancelacionStatus.search(item.status);

  if (status.isCancelled() || status.isDone()) {
    variant = 'success';
  } else if (status.isProcessing()) {
    variant = 'info';
  } else if (!status.isReceived()) {
    variant = 'danger';
  }

  return <Badge variant={variant}>{status.getName()}</Badge>;
};

const onRowRender = (item) => {
  return {
    className: item.highlight ? 'row-highlighted' : '',
  };
};

const columns = [
  {
    key: 'created_at',
    title: 'Fecha',
    dataIndex: 'created_at',
  },
  {
    key: 'cfdi_uuid',
    title: 'Cfdi Uuid',
    dataIndex: 'cfdi_uuid',
  },
  {
    key: 'rfc_emisor',
    title: 'Emisor',
    dataIndex: 'rfc_emisor',
  },
  {
    key: 'rfc_receptor',
    title: 'Receptor',
    dataIndex: 'rfc_receptor',
  },
  {
    key: 'motivo',
    title: 'Motivo',
    dataIndex: 'motivo',
    align: 'center',
  },
  {
    key: 'total',
    title: 'Total',
    dataIndex: 'total',
    align: 'right',
  },
  {
    key: 'tipo',
    title: 'Tipo',
    dataIndex: 'tipo',
  },
  {
    key: 'comentario',
    title: 'Comentario',
    dataIndex: 'comentario',
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: renderStatus,
  },
];

export default CancelacionesTicketList;
